(function () {
  'use strict';

  angular.module('app.blogPostOverview')
    .factory('blogPostOverviewService', ['$q', '$http', '$rootScope',
      function ($q, $http, $rootScope) {

        var service = {};

        function checkResponse(data) {
          return data;
        }

        function getMessage(data) {
          if (data) {
            return data.message;
          }
          return false;
        }

        function handleRequest(url) {
          var deferred = $q.defer(), result = 'requestFail';
          $http.get(url)
            .success(function (data) {
              var dataRes = angular.fromJson(data);

              if (checkResponse(dataRes)) {
                deferred.resolve(dataRes);
              } else {
                deferred.reject(getMessage(dataRes) || result);
              }
            })
            .error(function () {
              deferred.reject(result);
            });

          return deferred.promise;
        }

        function getBlogpostOverviewLineChart(url_hash, relativepath, published_date) {
          var url_getBlogpostOverviewLineChart = $rootScope.apiUrl + 'blogpost/getBlogpostOverviewLineChart?url_hash=' + (url_hash ? url_hash : '') + '&relativepath=' + (relativepath ? relativepath : '') + '&date=' + (published_date ? published_date : '');
          return handleRequest(url_getBlogpostOverviewLineChart);
        }

        function getBlogpostOverviewPieChart(url_hash, relativepath) {
          var url_getBlogpostOverviewPieChart = $rootScope.apiUrl + 'blogpost/getBlogpostOverviewPieChart?url_hash=' + (url_hash ? url_hash : '') + '&relativepath=' + (relativepath ? relativepath : '');
          return handleRequest(url_getBlogpostOverviewPieChart);
        }


        function getTop5PostsInSameInfluencer(influencer_id, url_hash) {
          var url_getTop5PostsInSameInfluencer = $rootScope.apiUrl + 'blogpost/getTop5PostsInSameInfluencer?influencer_id=' + (influencer_id ? influencer_id : 0) + '&url_hash=' + (url_hash ? url_hash : '');
          return handleRequest(url_getTop5PostsInSameInfluencer);
        }

        function getTop5PostsInSameTopic(influencer_id, url_hash, topic_id) {
          var url_getTop5PostsInAllInfluencer = $rootScope.apiUrl + 'blogpost/getTop5PostsInSameTopic?influencer_id=' + (influencer_id ? influencer_id : 0) + '&url_hash=' + (url_hash ? url_hash : '') + '&topic_id=' + (topic_id ? topic_id : 0);
          return handleRequest(url_getTop5PostsInAllInfluencer);
        }


        function getRelatedPosts(influencer_id, topic_id) {
          var url_getRelatedPosts = $rootScope.apiUrl + 'blogpost/getRelatedPosts?influencer_id=' + (influencer_id ? influencer_id : 0) + '&topic_id=' + (topic_id ? topic_id : 0);
          return handleRequest(url_getRelatedPosts);
        }

        service.getBlogpostOverviewLineChart = getBlogpostOverviewLineChart;

        service.getBlogpostOverviewPieChart = getBlogpostOverviewPieChart;

        service.getTop5PostsInSameInfluencer = getTop5PostsInSameInfluencer;

        service.getTop5PostsInSameTopic = getTop5PostsInSameTopic;

        service.getRelatedPosts = getRelatedPosts;

        return service;
      }]);

  

})();
